var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('div',{staticClass:"container"},[_c('navigation',{staticClass:"hide-mobile"}),_c('div',{staticClass:"right"},[_c('social'),_c('i-tech-labs',{staticClass:"gray"})],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }